<ng-container *ngIf="filter?.user?.value; else notSelected">
  <div class="drive-filter-item active" matRipple>
    <p class="flwmn-para-1 text-gray mb-0">
      <span class="text-white">{{ filter.user.name }}</span>
      <!-- {{ filter.user.value }} -->
    </p>

    <img
      matRipple
      src="assets/icons/close.svg"
      alt=""
      (click)="setUser(null)"
    />
  </div>
</ng-container>

<ng-template #notSelected>
  <div class="drive-filter-item" matRipple [matMenuTriggerFor]="user">
    <p class="flwmn-para-1 mb-0">Department</p>
    <img matRipple src="assets/icons/arrow-down.svg" alt="" />
  </div>

  <mat-menu #user="matMenu" class="menu filter-dropdown-menu">
    <!-- <p mat-menu-item class="flwmn-para-1 flwmn-text-neutral mb-0">
      DEPARTMENTS
    </p> -->

    <button mat-menu-item (click)="setUser({ name: 'All Departments' })">
      <div class="item-container">
        <p class="item-text text-black">All departments</p>
      </div>
    </button>

    <button
      mat-menu-item
      (click)="setUser(department)"
      *ngFor="let department of departments"
    >
      <div class="item-container">
        <!-- <div class="item-icon">
          <img matRipple src="assets/icons/profile-circle.svg" alt="" />
        </div> -->

        <p class="item-text text-black">{{ department?.name }}</p>
      </div>
    </button>
  </mat-menu>
</ng-template>
